const booking = {
  bookingInformation: "معلومات الحجز", // translated 
  cancellationPolicy: "سياسة الإلغاء", // translated 
  ourCancellationPolicy: "سياسة الإلغاء لدينا", // translated 
  thisAupersedesAnyCancellationPolicyInRemarksAbove:
    "وهذا يحل محل أي سياسة إلغاء مذكورة أعلاه", // translated 
  thisBookingIsNonNefundable: "هذا الحجز غير قابل للاسترداد", // translated 
  paymentTerms: "شروط الدفع", // translated 
  paymentWillBeTakenFromYourDefault: "سيتم أخذ الدفع من الافتراضي الخاص بك", // translated 
  paymentMethod: "طريقة الدفع او السداد", // translated 
  afterTheFreeCancellationPeriodIfApplicable:
    "بعد فترة الإلغاء المجانية إن وجدت", // translated 
  prebook: "الحجز المسبق", // translated 
  guests: "ضيوف", // translated 
  payment: "قسط", // translated 
  byClicking: "بالضغط", // translated 
  youAreAgreeingToOur: "أنت توافق على لدينا", // translated 
  termsAndConditions: "الأحكام والشروط", // translated 
  lastBookableDate: "آخر تاريخ للحجز", // translated 
  customerRemarksTextfield: "ملاحظات العملاء", // translated 
  request: "طلب", // translated 
};




export default booking;
